import { Trans, useTranslation } from 'react-i18next';
import { Card } from '@features/ui';
import { Downloaded, PlatformSelector } from '@features/user/downloads';
import { useState } from 'react';

export const DownloadsPage = () => {
  const { t } = useTranslation();

  const [dataDownloaded] = useState([]);

  return (
    <div className={'flex flex-col gap-y-4'}>
      <div className={'flex items-center gap-x-5'}>
        <h1 className={'text-[32px] font-medium'}>{t('downloads.title')}</h1>
        <p className={'text-xs'}>
          <Trans i18nKey={'downloads.desc'}>
            <strong className={'text-[#3490FF] underline cursor-pointer'} />
          </Trans>
        </p>
      </div>
      <Card>
        {dataDownloaded.length ? (
          <Downloaded src={'/assets/trading_view.png'} />
        ) : (
          <PlatformSelector />
        )}
      </Card>
    </div>
  );
};
